import React from "react";
import "../assets/styles.css";
import ServicesImage from "../assets/pad-pro-our-services.png";

export default function ServicesSectionA() {
  return (
    <section className="relative h-80 sm:h-96 lg:h-[450px] xl:h-[500px] overflow-hidden" data-aos="fade-up" data-aos-duration="1000">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${ServicesImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30 sm:from-black/60 sm:via-black/40 sm:to-transparent"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto text-center">
            
            <h1 className="text-3xl xs:text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-green-400 mb-3 sm:mb-4 lg:mb-6 newsreader leading-tight">
              Our Services
            </h1>
            
            <p className="text-xl xs:text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-white font-medium mb-3 sm:mb-4 lg:mb-6 newsreader leading-tight">
              Compassionate Care, Individualized Support
            </p>
            
            <p className="text-sm sm:text-base lg:text-lg xl:text-md text-gray-200 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto leading-relaxed px-4 sm:px-0">
              Discover how PADPro helps adults with intellectual disabilities thrive through 
              behavior management, skill development, and community-based programs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}